
import { BadgeCheck } from 'lucide-react';
import { RatingStars } from './RatingStars';
import { format } from 'date-fns';

interface ExternalRatingsProps {
  isVerified?: boolean;
  verificationDate?: string;
  googleRating?: number;
  googleReviewsCount?: number;
  trustpilotRating?: number;
  trustpilotReviewsCount?: number;
}

export const ExternalRatings = ({
  isVerified,
  verificationDate,
  googleRating,
  googleReviewsCount,
  trustpilotRating,
  trustpilotReviewsCount
}: ExternalRatingsProps) => {
  // Don't render anything if there are no ratings and the host is not verified
  if (!isVerified && !googleRating && !trustpilotRating) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 text-sm">
      {isVerified && (
        <div className="flex items-center gap-1 bg-green-50 text-green-700 px-2 py-0.5 rounded-full">
          <BadgeCheck className="w-3.5 h-3.5 flex-shrink-0" />
          <span className="text-xs font-medium whitespace-nowrap">
            {verificationDate 
              ? `Verified since ${format(new Date(verificationDate), 'MMM yyyy')}`
              : 'Verified Host'
            }
          </span>
        </div>
      )}
      
      {googleRating && googleRating > 0 && (
        <div className="flex items-center gap-1.5 bg-gray-50 px-2 py-0.5 rounded-full">
          <div className="w-3.5 h-3.5 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0">
            <span className="text-[8px] font-bold text-white">G</span>
          </div>
          <span className="text-xs font-medium">{googleRating.toFixed(1)}</span>
          <span className="text-xs text-gray-500 whitespace-nowrap">
            ({googleReviewsCount || 0})
          </span>
        </div>
      )}
      
      {trustpilotRating && trustpilotRating > 0 && (
        <div className="flex items-center gap-1.5 bg-gray-50 px-2 py-0.5 rounded-full">
          <div className="w-3.5 h-3.5 bg-[#00b67a] rounded-sm flex items-center justify-center flex-shrink-0">
            <span className="text-white text-[8px] font-bold">T</span>
          </div>
          <span className="text-xs font-medium">{trustpilotRating.toFixed(1)}</span>
          <span className="text-xs text-gray-500 whitespace-nowrap">
            ({trustpilotReviewsCount || 0})
          </span>
        </div>
      )}
    </div>
  );
};
